import React, { useState } from 'react';
import { useViewlogies } from 'context';
import { capitalizeFirst } from 'utils';

const MAX_CHARS = 225;

const Tooltip = ({ text, ariaLabel }) => {
    const [visible, setVisible] = useState(false);

    return (
        <span className="care-package-tooltip-container">
            <button
                className="care-package-tooltip-trigger"
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
                onClick={() => setVisible(v => !v)}
                aria-label={ariaLabel}
                type="button"
            >
                &#9432;
            </button>
            {visible && <div className="care-package-tooltip-text">{text}</div>}
        </span>
    );
};

const ReviewOrder = ({ product, message, fromName, onMessageChange, onFromNameChange, onNext }) => {
    const {
        event: { lastName, color },
    } = useViewlogies();

    const subtotal = product.price;
    const shipping = product.shippingFee;
    const tax = product.tax !== null && product.tax !== undefined ? product.tax : subtotal * 0.1025;
    const total = subtotal + shipping + tax;
    const charsRemaining = MAX_CHARS - message.length;

    return (
        <div className="care-package-review-order">
            <h3 className="care-package-section-title">Your Order</h3>

            <div className="care-package-order-summary">
                <div className="care-package-order-product">
                    <img src={product.images[0]} alt={product.name} className="care-package-order-thumbnail" />
                    <span className="care-package-order-product-name">{product.name}</span>
                </div>

                <div className="care-package-order-divider" />

                <div className="care-package-order-line">
                    <span>Subtotal</span>
                    <span className="care-package-subtotal-value">${subtotal.toFixed(2)}</span>
                </div>
                <div className="care-package-order-line">
                    <span className="care-package-order-line-label">
                        Shipping + Service Fee
                        <Tooltip
                            text={`We work with the ${capitalizeFirst(lastName)} family so they receive shipments at the optimal time`}
                            ariaLabel="Shipping info"
                        />
                    </span>
                    <span>${shipping.toFixed(2)}</span>
                </div>
                <div className="care-package-order-line">
                    <span className="care-package-order-line-label">
                        Estimated Tax
                        <Tooltip
                            text="Tax is determined by the required rate at the package's destination"
                            ariaLabel="Tax info"
                        />
                    </span>
                    <span>${tax.toFixed(2)}</span>
                </div>
                <div className="care-package-order-line care-package-order-total">
                    <strong>Total</strong>
                    <strong>${total.toFixed(2)}</strong>
                </div>
            </div>

            <div className="care-package-message-section">
                <label className="care-package-label">Care Package Message</label>
                <textarea
                    className="care-package-textarea"
                    placeholder="Add a note that will be attached to the care package"
                    value={message}
                    onChange={e => onMessageChange(e.target.value.slice(0, MAX_CHARS))}
                    rows={4}
                />
                <div className="care-package-char-count">{charsRemaining} characters remaining</div>
            </div>

            <div className="care-package-from-section">
                <label className="care-package-label">From</label>
                <input
                    className="care-package-input"
                    placeholder="Add your name"
                    value={fromName}
                    onChange={e => onFromNameChange(e.target.value)}
                />
            </div>

            <div className="care-package-actions">
                <button className="care-package-btn" style={{ backgroundColor: color }} onClick={onNext} type="button">
                    Continue
                </button>
            </div>
        </div>
    );
};

export default ReviewOrder;
